var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventClock1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 32 57",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2B875",
    d: "M23.042 49.452H8.451L3.83 53.94l2.535 2.398h18.78l2.522-2.391zM8.45 7.512h14.611l4.62-4.802L25.145 0H6.366L3.831 2.71zM7.512 48.1V32.701l-3.756-3.58L0 32.7v17.484l2.71 2.535zm0-24.25V8.45L2.71 3.832 0 6.366V23.85l3.756 3.574zm0 1.815v-.069l-2.742 2.71 2.742 2.868v.125H24.25l2.742-2.817-2.742-2.817z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2B875",
    d: "M24.413 32.701V48.12l4.476 4.607 2.41-2.541V32.7l-3.443-3.58zm0-24.251v15.4l3.443 3.574 3.443-3.574V6.366L28.9 3.831z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventClock1);
export default __webpack_public_path__ + "static/media/EventClock1.b61c17ad3b18b5bd9a459cc001044ebc.svg";
export { ForwardRef as ReactComponent };